import { cx } from './cx';

export function Spinner({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg className={cx('spinner', className)} width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function FullScreenSpinner({ label }: { label?: string }) {
  return (
    <div className="fullscreen-spinner" role="status" aria-live="polite">
      <Spinner size={40} />
      {label ? <div className="dim">{label}</div> : null}
    </div>
  );
}
